module.exports = __webpack_public_path__ + "img/sbl0010.49692cf6.png";